
import React from 'react';
import MainLayout from '../components/MainLayout';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import { FinalizeOrderCartItemModal } from '../components/modals/FinalizeOrderCartItemModal';
import PeopleCountModal from '../components/modals/PeopleCountModal';
import DigitalReceiptModal from '../components/modals/DigitalReceiptModal';
import SimpleTableTile from '../components/SimpleTableTile';
import PagerTile from '../components/PagerTile';
import LayoutModeToggle from '../components/LayoutModeToggle';
import ActiveStaffBadge from '../components/ActiveStaffBadge';
import '../styles/tableFormat.css';
import useTableOrdering from '../hooks/useTableOrdering';

const DashboardPage = () => {
  const {
    searchInputRef,
    selectedTables,
    seatingTabs,
    activeTab,
    search,
    multiSelect,
    occupiedTables,
    cartModal,
    setCartModal,
    peopleModal,
    setPeopleModal,
    receiptModal,
    closeReceiptModal,
    handleTabClick,
    handleSearch,
    handleMultiSelect,
    handleTableSelect,
    handlePagerTap,
    handlePeopleModalSuccess,
    handlePeopleModalNext,
    handleInfoClick,
    handleViewReceipt,
    printKitchenDocket,
    getElapsed,
    filteredTableData,
    handleCheckoutClick,
    anySelected,
    handleNext,
  } = useTableOrdering();

  const renderTables = (tabId) => {
    const list = filteredTableData[tabId] || [];
    const isSpecialTab = ["person-tab", "tabs-tab", "takeaway-tab", "pager-tab"].includes(tabId);

    return list.map(table => {
      const isSelected = (selectedTables?.[tabId] || []).includes(table.id);
      const info = occupiedTables[table.id];
      const isOccupied = !!info;

      if (tabId === 'pager-tab') {
        return (
          <PagerTile
            key={table.id}
            table={table}
            isOccupied={isOccupied}
            info={info}
            onTap={handlePagerTap}
            onViewReceipt={handleViewReceipt}
          />
        );
      }

      return (
        <SimpleTableTile
          key={table.id}
          table={table}
          tabId={tabId}
          isSelected={isSelected}
          isOccupied={isOccupied}
          info={info}
          isSpecialTab={isSpecialTab}
          onSelect={() => handleTableSelect(tabId, table.id, table.name || `${table.tableNumber}`)}
          onInfoClick={handleInfoClick}
          onCheckout={() => handleCheckoutClick(tabId, table.id)}
          onPrintKitchenDocket={(type) => printKitchenDocket(table.id, type)}
          getElapsed={getElapsed}
        />
      );
    });
  };

  const footerButtons = (
    <button
      className="btn iconBtn btnPrimary"
      onClick={handleNext}
      disabled={!anySelected}
    >
      <span>Next</span>
      <svg width="20" height="20" className="btnIcon">
        <use href="./images/sprite.svg#iconNextArrow" />
      </svg>
    </button>
  );

  return (
    <MainLayout
      footerButtons={footerButtons}
      footerCenter={(
        <div className="d-flex align-items-center gap-3">
          <LayoutModeToggle id="dashboardLayoutModeToggle" />
          <ActiveStaffBadge />
        </div>
      )}
    >
      <div className="pageContent selectTablePage">
        <div className="container">
          <div className="seatingArea">
            <div className="tabStyle" role="tablist">
              <Swiper
                className="seatingSwiper"
                slidesPerView="auto"
                spaceBetween={50}
                speed={500}
                navigation={{ nextEl: '.sTabNext', prevEl: '.sTabPrev' }}
                modules={[Navigation]}
              >
                {seatingTabs.map(tab => (
                  <SwiperSlide key={tab.id} className="w-auto">
                    <button
                      className={`nav-link${activeTab === tab.id ? ' active' : ''}`}
                      onClick={() => handleTabClick(tab.id)}
                    >
                      <svg width="40" height="40"><use href={tab.icon} /></svg>
                      {tab.label}
                    </button>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="tabHeaderRow">
                <form className="formStyle searchStyle tabSearchInput">
                  <svg width="17" height="18" className="searchIcon">
                    <use xlinkHref="/images/sprite.svg#iconSearch" />
                  </svg>
                  <input
                    ref={searchInputRef}
                    type="text"
                    className="form-control"
                    placeholder="Search a Table Number"
                    value={search}
                    onChange={handleSearch}
                  />
                </form>


                <div className="multiSelectPlaceholder " />
              </div>
              <div className="tab-content">
                {seatingTabs.map(tab => (
                  <div
                    key={tab.id}
                    className={`tab-pane fade${activeTab === tab.id ? ' show active' : ''}`}
                  >
                    <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between mb-4 mb-xl-5">

                      <div className="form-check form-switch mb-0 multiSelectTrigger">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`multiSelect-${tab.id}`}
                          checked={multiSelect[tab.id]}
                          onChange={() => handleMultiSelect(tab.id)}
                        />
                        <label className="form-check-label" htmlFor={`multiSelect-${tab.id}`}>
                          Multiple Select
                        </label>
                      </div>
                    </div>
                    <div
                      className={`d-flex flex-wrap justify-content-center mx-auto col-10${tab.id === 'pager-tab' ? ' pagerGrid' : ' gap-5'}`}
                    >
                      {renderTables(tab.id).length > 0 ? renderTables(tab.id) : <p>No tables found</p>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <FinalizeOrderCartItemModal
          isOpen={cartModal.open}
          tableId={cartModal.tableId}
          tableName={cartModal.tableName}
          onClose={() => setCartModal({ open: false })}
        />
        <PeopleCountModal
          isOpen={peopleModal.open}
          tableId={peopleModal.tableId}
          tableName={peopleModal.tableName}
          onClose={() =>
            setPeopleModal({ open: false, tabId: null, tableId: null, tableName: '' })
          }
          onSuccess={handlePeopleModalSuccess}
          onNext={handlePeopleModalNext}
        />
        <DigitalReceiptModal
          isOpen={receiptModal.open}
          orderId={receiptModal.orderId}
          tableId={receiptModal.tableId}
          paymentMethod={receiptModal.paymentMethod}
          summary={receiptModal.summary}
          tableLabel={receiptModal.tableLabel}
          serverName={receiptModal.serverName}
          onClose={closeReceiptModal}
        />
      </div>
    </MainLayout>
  );
};

export default DashboardPage;
